module.exports = __webpack_public_path__ + "static/media/olive.df50909a.jpg";